document.addEventListener('DOMContentLoaded', () => {
    const successMessageContainer = document.getElementById('upsell-success--container');
    const successMessageTranslation = document.getElementById('success-message-translation').innerHTML;

    document.addEventListener("click", function(e) {
        const atcBtns = e.target.closest(".js-upsell-atc");
        console.log("clicked!");
        if (!atcBtns || atcBtns.classList.contains("is-loading")) return;

        const variantId = atcBtns.dataset.variantId;
        const productTitle = atcBtns.dataset.variantName;

        const plusIcon = atcBtns.querySelector('.upsell-atc__icon--plus');
        const spinnerIcon = atcBtns.querySelector('.upsell-atc__icon--spinner');

        atcBtns.classList.add('is-loading');
        plusIcon.hidden = true;
        spinnerIcon.hidden = false;

        console.log("prod title", productTitle);

         const formData = new FormData();
        formData.append("id", variantId);;
        formData.append("quantity", 1);

        window.Cart.addToCart(formData)
        .then(() => {
            successMessageContainer.innerHTML = productTitle + ' ' + successMessageTranslation;
        })
        .catch(err => {
            console.log("Cart error:", err);
        })
        .finally(() => {
            atcBtns.classList.remove("is-loading");
            plusIcon.hidden = false;
            spinnerIcon.hidden = true;
        });
    });

});